import { C } from "../theme/colors";

export default function PageHero({ title, subtitle, tag, children }) {
  return (
    <div style={{background:`linear-gradient(135deg, ${C.navyDark} 0%, ${C.navy} 55%, ${C.blue} 100%)`,padding:"27px 40px 29px",position:"relative",overflow:"hidden"}}>
      <svg style={{position:"absolute",right:-40,bottom:-40,opacity:.06}} width="420" height="420" viewBox="0 0 420 420">
        <circle cx="210" cy="210" r="200" fill="none" stroke="white" strokeWidth="1"/>
        <circle cx="210" cy="210" r="150" fill="none" stroke="white" strokeWidth="1"/>
        <circle cx="210" cy="210" r="100" fill="none" stroke="white" strokeWidth="1"/>
        <circle cx="210" cy="210" r="50" fill="none" stroke="white" strokeWidth="1"/>
        <line x1="10" y1="210" x2="410" y2="210" stroke="white" strokeWidth=".5"/>
        <line x1="210" y1="10" x2="210" y2="410" stroke="white" strokeWidth=".5"/>
      </svg>
      <div style={{maxWidth:1260,margin:"0 auto",position:"relative"}}>
        <div style={{display:"inline-block",background:"rgba(255,255,255,0.12)",border:"1px solid rgba(255,255,255,0.2)",borderRadius:4,padding:"4px 12px",marginBottom:20}}>
          <span style={{fontFamily:"Arial,Helvetica,sans-serif",fontSize:10.5,color:"rgba(255,255,255,0.85)",letterSpacing:2,fontWeight:600,textTransform:"uppercase"}}>{tag||"CRENS @ BITS PILANI"}</span>
        </div>
        <h1 style={{fontFamily:"var(--font-heading)",fontWeight:700,color:C.white,fontSize:"clamp(2rem,4vw,2.8rem)",lineHeight:1.1,marginBottom:18}}>{title}</h1>
        <div style={{width:48,height:3,background:C.goldLight,borderRadius:2,marginBottom:20}}/>
        {subtitle && <p style={{fontFamily:"Arial,Helvetica,sans-serif",fontSize:16,color:"rgba(255,255,255,0.72)",maxWidth:580,lineHeight:1.85}}>{subtitle}</p>}
        {children}
      </div>
    </div>
  );
}